// extracted by mini-css-extract-plugin
export default {"HeaderAuthed__avatar":"HeaderAuthed_HeaderAuthed__avatar__QMwkX","HeaderAuthed__link":"HeaderAuthed_HeaderAuthed__link__kzqkw"};